import { ComponentsProps, ComponentsOverrides, ComponentsVariants, Theme } from '@mui/material';

export const MuiChip: {
    defaultProps?: ComponentsProps['MuiChip'];
    styleOverrides?: ComponentsOverrides<Theme>['MuiChip'];
    variants?: ComponentsVariants['MuiChip'];
} = {
    styleOverrides: {
        root: (props) => [
            props.theme.typography.chip,
            {
                padding: props.theme.spacing(props.theme.tokens.spacing.xxs),
                borderRadius: props.theme.borderRadius(props.theme.tokens.borderRadius.sm),
                height: 'unset',
                '& .MuiChip-label': {
                    padding: props.theme.spacing(props.theme.tokens.spacing.none),
                },
            },
        ],
    },
};
